import { Duration } from '@piccolohealth/util';
import React from 'react';
import { useController } from 'react-hook-form';
import { DurationInput, type DurationInputProps } from './DurationInput';

interface Props extends Omit<DurationInputProps, 'value' | 'onChange'> {
  name: string;
}

export const HookedDurationInput = (props: Props) => {
  const { name, ...rest } = props;

  const {
    field: { ref, ...inputProps },
  } = useController({ name });

  const onChange = (duration: Duration) => {
    inputProps.onChange(duration.as('seconds'));
  };

  const value = Duration.fromObject({ seconds: inputProps.value ?? 1 });

  return <DurationInput {...rest} value={value} onChange={onChange} />;
};
